import React, { useEffect, useState } from "react";

import CustomCountDown from "../CustomCountDown";
import { AiFillEdit, AiFillInfoCircle } from "react-icons/ai";
import loader from "../../assets/icons/loader.gif";
import dynamic from "next/dynamic";
import Image from "next/image";
import axiosInterceptorInstance from "../axiosInterceptorInstance";
import Actions from "../Actions";
import axios from "axios";
import { FaceBook } from "../FaceBook";
import { Mixpanel } from "../Mixpanel";
import app_download_qr from "../../assets/Images/app_download_qr.webp";
import Link from "next/link";
import { BsApple, BsTelephone } from "react-icons/bs";

const OtpInput = dynamic(() => import("react-otp-input"), { ssr: false });

export default function LogInBf({
    setActivateClicked = () => null,
    setModal,
    number,
    inputRef,
    sendOtp,
    userData,
    setUserData,
    isProPage,
    btn
}) {
    const [otp, setOtp] = useState("");
    const [error, setError] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [btnClicked, setDtnClicked] = useState(false);
    const [showCountDown, setShowCountDown] = useState(true);
    const handleResend = () => {
        sendOtp();
        setDisabled(true);
        setError(false);
        setShowCountDown(true);
        Mixpanel.track("cta_clicked", {
            page: btn?.page,
            cta_text: "resend"
        });
    };
    const handleVerify = () => {
        setDtnClicked(true);
        axiosInterceptorInstance
            .post(`api/auth/verify-otp`, {
                type: "web4",
                contactNumber: number,
                countryCode: 91,
                otp: otp,
                referralCode: null,
                logoutAllDevices: false,
                userInterest: isProPage ? "web-pro" : "web-elite"
            })
            .then((res) => {
                if (res.data?.data?.authToken) {
                    setActivateClicked(false);
                    Mixpanel.identify(`${res.data?.data?.id}`, {
                        $email: `${res.data?.data?.email ?? ""}`,
                        $name: `${res.data?.data?.firstName ?? ""}`,
                        $phone: `${res.data?.data?.contactNumber ?? ""}`,
                        subscriptionState: `${res.data?.data?.subscriptionState ?? ""}`
                    });
                    // setModal(false)
                    Actions.setCookie("auth_token", res.data?.data?.authToken, 7);
                    getUserInfo(res.data?.data);
                } else {
                    setError(true);
                }
            })
            .catch((e) => {
                setError(true);
            })
            .finally((f) => setDtnClicked(false));

        Mixpanel.track("cta_clicked", {
            page: btn?.page,
            cta_text: "verify"
        });
    };

    const setUserInfo = (data) => {
        setUserData(data);
        Actions.setCookie("user_details", JSON.stringify(data), 7);
    };

    const getUserInfo = (data) => {
        axiosInterceptorInstance.get(`resources/users/user-info-v4`).then((ress) => {
            if (ress.data?.data?.subscriptionState === "FREE") {
                Mixpanel.track("new_user_login", {
                    page: btn?.page
                });
                Mixpanel.track(`new_user_login_${btn?.page}`);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "new_user_login",
                    page: btn?.page,
                    user_id: ress.data?.data?.id
                });
            }
            if (ress.data?.data?.subscriptionState === "FREE" && !isProPage) {
                FaceBook.track("ViewContent");
                axiosInterceptorInstance.post(`resources/faircent`, {
                    leadType: "elite",
                    expectedReturn: 8.25,
                    planName: `No lock-in`,
                    minAmount: 25000,
                    investmentDuration: 0
                });
            }
            if (ress.data?.data?.subscriptionState === "FREE" && isProPage) {
                axios
                    .put(
                        `${process.env.apiBaseURL}/resources/user-subscription/activate-trial-v3`,
                        {},
                        {
                            headers: {
                                Authorization: `Bearer ${Actions.getCookie("auth_token")}`,
                                "device-name": Actions.getDeviceName(),
                                "device-id": Actions.generateUniqueDeviceID()
                            }
                        }
                    )
                    .then((res) => {
                        if (res.data?.data) {
                            getUserInfo(data);
                            FaceBook.track("StartTrial");
                        } else {
                            Mixpanel.track("unable_to_start_trial");
                            setUserInfo({
                                ...data,
                                notAbleStartTrial: true,
                                subscriptionState: "TRIAL_PRO_SUPER_EXPIRED"
                            });
                        }
                    })
                    .catch((err) => {
                        setUserInfo({
                            ...data,
                            notAbleStartTrial: true,
                            subscriptionState: "TRIAL_PRO_SUPER_EXPIRED"
                        });
                    });
            } else {
                setUserInfo({
                    ...data,
                    subscriptionState: ress.data?.data?.subscriptionState,
                    expiryDate: ress.data?.data?.expiryDate,
                    planName: ress.data?.data?.activePlanProjectionList?.[0]?.planName
                });
            }
        });
    };

    useEffect(() => {
        if ("OTPCredential" in window) {
            const ac = new AbortController();
            navigator.credentials
                .get({
                    otp: { transport: ["sms"] },
                    signal: ac.signal
                })
                .then((otp) => {
                    setOtp(otp?.code);
                    ac.abort();
                })
                .catch((err) => {
                    ac.abort();
                    // console.log(err);
                });
        }
    }, []);

    return (
        <div className="flex md:flex-row justify-between gap-20">
            <div className="mx-1 t-4 rounded-t-2xl font-Inter w-full">
                <div className="flex justify-center items-center">
                    <div className="text-xl font-medium text-[#202020] text-center">+91-{number}</div>

                    <span
                        className="text-primary text-sm ml-3 font-semibold flex items-center"
                        onClick={() => {
                            setModal(false);
                            inputRef.current?.focus();
                        }}
                    >
                        Edit
                        <AiFillEdit color="#0862BC" className="text-base ml-1" />
                    </span>
                </div>
                <div className="text-xs font-medium text-[#8A8A8A] text-center mt-1">
                    OTP has been sent to the shared number
                </div>
                <div className="text-base font-semibold text-black text-center mt-6">Enter OTP</div>
                <OtpInput
                    shouldAutoFocus={true}
                    containerStyle={{ justifyContent: "space-evenly", padding: "16px 0px 4px 0px" }}
                    inputStyle={{
                        border: "1px solid black",
                        width: "44px",
                        height: "44px",
                        borderRadius: "4px",
                        fontSize: "20px",
                        fontWeight: 500
                    }}
                    isInputNum={true}
                    value={otp}
                    onChange={(e) => {
                        setOtp(e);
                        setError(false);
                    }}
                    numInputs={4}
                    hasErrored={error}
                    renderInput={(props) => <input {...props} />}
                    errorStyle={{ border: "1px solid #EB4E2C" }}
                />
                <div className="flex justify-start items-center mt-[6px]">
                    <AiFillInfoCircle color={error ? "#EB4E2C" : "#747474"} className="text-[12px] mr-1" />
                    <div
                        className={`${
                            error ? "text-[#EB4E2C]" : "text-[#202020]"
                        } text-[10px] leading-[16px] font-medium`}
                    >
                        {error ? "Please enter correct OTP." : "This is required"}
                    </div>
                </div>
                <div className="flex flex-row justify-between mb-10">
                    <div className="basis-1/2 flex items-center justify-start">
                        <button
                            disabled={disabled}
                            type="button"
                            className="whitespace-nowrap rounded-md py-3 text-[12px] leading-[20px] text-[#00439D] disabled:text-[#BCBCBC] outline-none font-semibold"
                            onClick={handleResend}
                        >
                            Resend OTP
                        </button>
                        {showCountDown && (
                            <CustomCountDown
                                sec={30}
                                onComplete={() => {
                                    setDisabled(false);
                                    setShowCountDown(false);
                                }}
                            />
                        )}
                    </div>
                    <div className="basis-1/2 text-left">
                        <button
                            id={isProPage ? "ProOtpVerified" : "EliteOtpVerified"}
                            disabled={otp.length !== 4 || btnClicked}
                            type="button"
                            className="rounded-md w-full py-3 bg-[#202020] disabled:bg-[#BCBCBC] text-[#FFFFFF] text-[14px] leading-[24px] outline-none font-semibold"
                            onClick={handleVerify}
                        >
                            {btnClicked ? (
                                <Image src={loader} alt="icon" className="h-6 object-contain mx-auto" />
                            ) : (
                                "Verify OTP"
                            )}
                        </button>
                    </div>
                </div>
            </div>
            <div className="md:flex flex-col justify-between hidden ">
                <div className="p-2 border border-black rounded">
                    <Image src={app_download_qr} className="w-28" alt="download now qr" />
                </div>
                <p className="text-sm text-black mb-3 text-center">Scan to Download</p>
                <Link
                    href="https://play.google.com/store/apps/details?id=com.univest.capp"
                    className="bg-black flex items-center border rounded-lg px-2 py-1 w-32 transition hover:opacity-75"
                >
                    <Image
                        src="https://cdn-icons-png.flaticon.com/512/888/888857.png"
                        width={20}
                        height={20}
                        className="w-6"
                        alt="Google Play"
                    />
                    <div className="text-left ml-2">
                        <p className="text-[8px] text-white">Download on </p>
                        <p className="text-xs font-bold text-white">Google Play</p>
                    </div>
                </Link>
                <Link
                    href="https://apps.apple.com/us/app/univest-empowering-wealth/id6443753518"
                    aria-label="Download on Apple Store"
                    className="bg-black flex items-center border rounded-lg px-2 py-1.5 w-32 transition hover:opacity-75"
                >
                    <BsApple color="#FFFFFF" size={24} />
                    <div className="text-left ml-2">
                        <p className="text-[8px] text-white">Download on </p>
                        <p className="text-xs font-bold text-white">Apple Store</p>
                    </div>
                </Link>
            </div>
        </div>
    );
}
